import { getAuthAxiosBackend } from "../../helpers/axios"

class EmployeeServices{

    get(id){
        return getAuthAxiosBackend().get('government-loans/employees/'+id.toString())
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('government-loans/employees', {params: data})
    }

    delete(id){
        return getAuthAxiosBackend().delete('government-loans/employees/' + id)
    }
}

export default new EmployeeServices()